import React from 'react';

/**
 * Layout skeleton for public vehicle profile initial load.
 * Site AppHeader is global, so this only sketches page body.
 */
export const PublicVehiclePageSkeleton: React.FC = () => (
  <div className="min-h-screen bg-gradient-to-b from-[#0a0a0a] via-[#0a0a0a] to-[#0a0a0a] animate-pulse">
    <div className="aspect-[16/10] sm:aspect-[21/9] max-h-[50vh] bg-[#0a0a0a]/80 border-b border-white/[0.06]" />

    <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8 space-y-6 sm:space-y-8">
      <section className="rounded-2xl border border-white/[0.06] bg-[#0c0c0c]/50 p-5 sm:p-7 space-y-4">
        <div className="h-3 w-28 bg-[#141414] rounded" />
        <div className="h-9 w-4/5 max-w-md bg-[#141414] rounded" />
        <div className="h-5 w-1/2 max-w-xs bg-[#141414]/80 rounded" />
        <div className="flex items-center gap-3 pt-4 border-t border-white/[0.06]">
          <div className="w-11 h-11 rounded-full bg-[#141414]" />
          <div className="space-y-2 flex-1">
            <div className="h-3 w-16 bg-[#141414] rounded" />
            <div className="h-4 w-32 bg-[#141414] rounded" />
          </div>
        </div>
        <div className="grid grid-cols-3 gap-px bg-[#141414]/80 rounded-xl overflow-hidden border border-white/[0.06] max-w-md">
          {[1, 2, 3].map((i) => (
            <div key={i} className="bg-[#0a0a0a]/60 px-3 py-4 text-center space-y-2">
              <div className="h-6 w-10 bg-[#141414] rounded mx-auto" />
              <div className="h-2 w-14 bg-[#141414]/80 rounded mx-auto" />
            </div>
          ))}
        </div>
      </section>

      <section className="rounded-2xl border border-white/[0.06] bg-[#141414]/40 p-5 sm:p-6 space-y-4">
        <div className="h-3 w-24 bg-[#141414] rounded" />
        <div className="h-6 w-48 bg-[#141414] rounded" />
        <div className="border border-white/[0.06] rounded-xl overflow-hidden divide-y divide-white/[0.06]/80">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="px-4 py-4 flex flex-col sm:flex-row sm:gap-4 gap-2">
              <div className="h-3 w-20 bg-[#141414] rounded" />
              <div className="h-4 flex-1 max-w-xs bg-[#141414]/80 rounded" />
            </div>
          ))}
        </div>
      </section>
    </main>
  </div>
);

export default PublicVehiclePageSkeleton;
